import { cancellationThunksFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.thunks';

export const limitOrderCancellationThunks = cancellationThunksFactory('LIMIT_ORDER');
